// extracted by mini-css-extract-plugin
export default {"header":"KxvhQ","header-content":"jVlPE","header-main":"L_jtj"};